export const ROUTE = {
  ADMIN: '/v2/admin',
  ADMIN_BROWSE: '/v2/admin/browse',
  ADMIN_BROWSE_CATEGORIES: '/v2/admin/browse/categories',
  ADMIN_BROWSE_HOME_LIST: '/v2/admin/browse/home/:localeCode?',
  ADMIN_BROWSE_HOME_CREATE: '/v2/admin/browse/home/:localeCode/create',
  ADMIN_BROWSE_HOME_EDIT: '/v2/admin/browse/home/:localeCode/edit/:browseHomePageId'
};

export const TEMP_CATEGORY_ID_PREFIX = 'temp-';

export const TOP_LEVEL_CATEGORY_ID = {
  COLLECTION: 'collection',
  FORMAT: 'format',
  GENRE: 'genre'
};

export const TOP_LEVEL_CATEGORY_TITLE_BY_ID = {
  [TOP_LEVEL_CATEGORY_ID.COLLECTION]: 'Collection',
  [TOP_LEVEL_CATEGORY_ID.FORMAT]: 'Format',
  [TOP_LEVEL_CATEGORY_ID.GENRE]: 'Genre'
};
